
import { Component, Vue, Prop } from "vue-property-decorator";
import { API_TDocumentCard } from "@/models/document_cards";
import { SMDocuments, SMUser } from "@/store";
import { API_ROUTES } from "@/utils/API";

import {
  DEFAULT_FILE_TYPE,
  COS_FILE_TYPE,
  IELTS_FILE_TYPE,
  PTE_FILE_TYPE,
  OUTDATED_FILE_STATUS,
} from "@/constants/files";

import { SUCCESS_DOCUMENT_STATUS, ERROR_DOCUMENT_STATUS } from "@/constants/documents";

@Component({
  components: {
    ActionContainerCard: () => import("@/components/ActionContainer/ActionContainerCard.vue"),
    FormCOSCompliance: () =>
      import(
        "@/components/DocumentViewCards/views/Card/components/forms/COS/FormCOSCompliance.vue"
      ),
    FormCOSCases: () =>
      import("@/components/DocumentViewCards/views/Card/components/forms/COS/FormCOSCases.vue"),
    FormIELTS: () =>
      import("@/components/DocumentViewCards/views/Card/components/forms/IELTS/FormIELTS.vue"),
    FormPTE: () =>
      import("@/components/DocumentViewCards/views/Card/components/forms/PTE/FormPTE.vue"),
  },
})
export default class DocumentCardDetails extends Vue {
  @Prop({ type: Object }) readonly documentCard?: API_TDocumentCard;
  @Prop({ type: Boolean, default: false }) readonly canUploadFile?: boolean;
  @Prop({ type: Object }) readonly details?: any;

  cosFormSubmitted = false;

  isConfirmLoading = false;

  showDetails = true;

  get title() {
    if (this.isCos) return this.$tc("details.titleCos");

    if (this.isIelts) return this.$tc("details.titleIelts");

    if (this.isPte) return this.$tc("details.titlePte");

    return "";
  }

  get fileType() {
    return this.documentCard?.document_template.file_type || DEFAULT_FILE_TYPE;
  }

  get isIelts() {
    return this.fileType === IELTS_FILE_TYPE;
  }

  get isCos() {
    return this.fileType === COS_FILE_TYPE;
  }

  get isPte() {
    return this.fileType === PTE_FILE_TYPE;
  }

  get isExpert() {
    return SMUser.isExpert;
  }

  get caseId(): number {
    return Number(this.$route.params.id ?? 0);
  }

  get isCOSCompliance() {
    if (this.caseId) return false;

    return !!this.isCos;
  }

  get isCosCases() {
    return !!this.caseId && !!this.isCos;
  }

  get hasDetails() {
    return !!this.details;
  }

  get isDataConfirmed() {
    return this.cosFormSubmitted || this.documentCard?.is_data_confirmed;
  }

  get activeUploadedFiles() {
    return SMDocuments.activeUploadedFiles.filter((file) => file.status !== OUTDATED_FILE_STATUS);
  }

  created() {
    this.showDetails = true;
  }

  async confirm(form: any) {
    this.isConfirmLoading = true;

    try {
      if (!this.documentCard) return;

      await this.axios.post(API_ROUTES.COS_FORM_DOCUMENT_CONFIRM(this.documentCard.ID), form);

      this.cosFormSubmitted = true;

      this.showDetails = false;

      this.$emit("update");

      SMDocuments.setDocumentCardStatus(SUCCESS_DOCUMENT_STATUS);
    } catch {
      SMDocuments.setDocumentCardStatus(ERROR_DOCUMENT_STATUS);
    } finally {
      this.isConfirmLoading = false;
    }
  }
}
